<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mb-2" color="primary" v-bind="attrs" v-on="on">
          Menu
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="clickedMenuItem('new-student-schedule')">
          <v-list-item-icon>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>New Student Schedule</v-list-item-title>
        </v-list-item>
        <v-list-item @click="clickedMenuItem('new-teacher-schedule')">
          <v-list-item-icon>
            <v-icon>mdi-account-plus-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>New Teacher Schedule</v-list-item-title>
        </v-list-item>
        <v-list-item @click="clickedMenuItem('closure-schedule')">
          <v-list-item-icon>
            <v-icon>mdi-calendar-remove-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Holiday &amp; Closure Schedule</v-list-item-title>
        </v-list-item>
        <v-list-item @click="clickedMenuItem('student-attendance')">
          <v-list-item-icon>
            <v-icon>mdi-account-alert</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Student Attendance</v-list-item-title>
        </v-list-item>
        <v-list-item @click="clickedMenuItem('scheduling-activities')">
          <v-list-item-icon>
            <v-icon>mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Scheduling Activities</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="
            openNewPage({
              name: 'PrintSchedules',
              params: { start: startDate, end: endDate },
            })
          "
        >
          <v-list-item-icon>
            <v-icon>mdi-printer</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Print Schedules</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <pre v-if="dialogMode == 'debug'"> {{ dialogContent }} </pre>
          <component
            v-else
            :is="dialogMode"
            v-bind="dialogData"
            @on-close="onDialogClose"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  openAttendance,
  openNewStudentSchedule,
  openNewTeacherSchedule,
  openClosureSchedule,
  openSchedulingActivities
} from "./eventHandler.js";
import moment from "moment";

export default {
  props: {},
  data: () => ({
    dialog: false,
    dialogMode: "",
    dialogTitle: "",
    dialogContent: "",
    dialogData: {},
  }),
  computed: {
    startDate() {
      return this.dateRange
        ? moment(this.dateRange.start).format("YYYY-MM-DD")
        : null;
    },
    endDate() {
      return this.dateRange
        ? moment(this.dateRange.end).format("YYYY-MM-DD")
        : null;
    },
  },
  methods: {
    clickedMenuItem(menu) {
      switch (menu) {
        case "student-attendance":
          openAttendance();
          break;
        case "new-student-schedule":
          openNewStudentSchedule({});
          break;
        case "new-teacher-schedule":
          openNewTeacherSchedule({});
          break;
        case "closure-schedule":
          openClosureSchedule({});
          break;
        case "scheduling-activities":
          openSchedulingActivities({});
          break;
      }
    },
    openNewPage(routeObj) {
      const { name, params } = routeObj;
      const route = this.$router.resolve({ name, params });
      const url = route.href + "?" + this.serializeParams(params);
      window.open(url, "_blank");
    },
    serializeParams(params) {
      const encodedParams = Object.keys(params)
        .map(
          (key) =>
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
        )
        .join("&");
      return encodedParams;
    },
    onDialogClose() {
      this.dialog = false;
    },
  },
};
</script>
